export default __webpack_public_path__ + "static/media/143.0abc9bb3.png";